import React,{Component} from 'react';
import ListSubheader from 'material-ui/List/ListSubheader';
import List from 'material-ui/List';
import Chip from 'material-ui/Chip';
import Divider from 'material-ui/Divider';
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
class Label extends Component{
    constructor(){
        super();
        this.state={
            load:false,
            labelArray:[]
        }
    }
    componentDidMount(){
        this.handleGetJson();
    }

    handleGetJson(){
        this.setState({
            load:false
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/label').then(response=>{

            const data=response.data;
            if (response.code==1){
                this.setState({
                    load:false,
                    labelArray:data
                })
                console.log("加载label成功"+data.length)
            }else {
                this.handleLoginError();
                console.log("加载label失败")
            }
            this.setState({load:false})
        },error=> {
            this.setState({load:false})
        })
    }
    handleClick(key,event){

        getJSON('http://123.207.90.121:8080/newBlog/api/getBlogsByLabel',{label:key}).then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.props.handleBlogArray(data);
                console.log("加载blog成功"+data.length)
            }else {
                this.props.handleBlogArray([]);
                console.log("加载blog失败")
            }
            this.setState({load:false})
        },error=> {
            this.setState({load:false})
        })

    }

    render(){

        if (this.state.load){
            return (<table valign="medium" align="center" style={{width:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                </td></tr></tbody></table>)
        }

        return(
            <div style={{background: 'white'}}>

                <List  component="nav" style={{padding:'2px'}}  subheader={<ListSubheader  component="div">Label</ListSubheader>}>
                    <Divider/>
                    <div style={{textAlign:'center'}}>
                        {this.state.labelArray.map((label)=>{
                            return(

                            <Chip key={label.labelId}  onClick={this.handleClick.bind(this,label.labelName)} style={{margin:'3px',background:'white',height:'20px',backgroundColor:'#D8D8D8'}}
                                  label={label.labelName}
                            />
                            )
                        })}

                    </div>
                </List>

            </div>

        )
    }
}
export default Label;


// WEBPACK FOOTER //
// ./src/Compent/page/Label.js